import makeStyles from '@mui/styles/makeStyles';

const useCustomTextFieldStyles = makeStyles({
  root: {}
});

export default useCustomTextFieldStyles;
